import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import config from '../config';

import '../styles/global.css';

import MobileHeader from '../components/general/mobileHeader.js';
import Sidebar from '../components/general/sidebar.js';
import ChatViewForm from '../components/chat/chatViewForm.js';

const API_URL = config.API_URL || 'http://localhost:5000';

const MainLayout = ({ children, formType, showChatForm, onCloseForm, onConfirmForm, onCancelForm }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const location = useLocation();
  const isAIChatPage = location.pathname === '/aichat';

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 640;
      setIsMobile(mobile);
      setIsCollapsed(mobile);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Collapse sidebar on AI chat page for desktop view
  useEffect(() => {
    if (!isMobile && isAIChatPage) {
      setIsCollapsed(true);
    }
  }, [isAIChatPage, isMobile]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${API_URL}/v2/auth/authenticate`, {
          headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`},
        });
        setCurrentUser(response.data);
      } catch (error) {
        console.error("Error fetching user information:", error);
      }
    };
    fetchUser();
  }, []);

  return (
    <div className="flex flex-col sm:flex-row transition-all duration-500 relative">

      {/* Mobile Header */}
      {isMobile && <MobileHeader toggleSidebar={toggleSidebar} />}
      {/* Backdrop */}
      {isMobile && !isCollapsed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`
          ${isMobile
            ? isCollapsed
              ? 'hidden'
              : 'fixed top-0 left-0 w-4/5 h-full z-50 bg-[#FCE5CD] p-5'
            : 'relative'}
        `}
      >
        <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} User={currentUser} />
      </div>

      {/* Content */}
      <div
        className={`w-full overflow-y-auto transition-all duration-500 flex flex-row
          ${!isMobile && (isCollapsed ? 'md:pl-[110px]' : 'md:pl-[290px]')}
          p-5`}
      >
        {(!isMobile || !showChatForm) && children}
        {isAIChatPage && showChatForm && (
          <div
            className={`ellie-ai-form flex flex-col h-[calc(100vh-35px)] 
        ${isMobile ? "w-full ml-0" : "w-[480px] ml-6"}`}
          >
            <ChatViewForm
              formType={formType}
              onClose={onCloseForm}
              onConfirm={onConfirmForm}
              onCancel={onCancelForm}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainLayout;
